module.exports = __webpack_public_path__ + "static/media/facebook.c01c0475.svg";